import { useHttp } from "@/composables/useHttp"

export function useSidebarHttp() {
  const http = useHttp()

  async function sidebarInfo() {
    const sidebar = await http.get('sidebar')

    return sidebar.data.data
  }

  return {
    sidebarInfo,
  }
}
